import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, TemplateRef } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateSearchConditionPipe } from '../../pipe/translate-search-condition.pipe';
import { SearchTag } from './../../model/search-tag.model';
import { SearchTagService } from '../../service/search-tag.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-search-tag',
  templateUrl: './search-tag.component.html',
  styleUrls: ['./search-tag.component.scss']
})
export class SearchTagComponent implements OnInit, OnDestroy {
  @Input() searchTag: SearchTag;
  @Output() clickedQoalaTag = new EventEmitter<any>();
  @Output() clickedUserTag = new EventEmitter<SearchTag>();

  targetUserTag: SearchTag;
  private subscriptions: Subscription = new Subscription();

  constructor(
    private modalService: NgbModal,
    private searchTagService: SearchTagService,
    private translateSearchConditionPipe: TranslateSearchConditionPipe
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  clickQoalaTag(): void {
    this.searchTag.is_activated = !this.searchTag.is_activated;
    this.clickedQoalaTag.emit();
  }

  clickUserTag(): void {
    this.clickedUserTag.emit(this.searchTag);
  }

  openConfirmDeleteUserTagModal(content: TemplateRef<any>) {
    this.modalService.open(content, { centered: true });
  }

  // 青タグ 削除
  deleteUserTag(): void {
    const deleteSub = this.searchTagService.deleteSearchTag(this.searchTag).subscribe(res => {
      this.modalService.dismissAll();
      this.searchTagService.searchTagListSubject.next();
    });
    this.subscriptions.add(deleteSub);
  }

  searchContents(): Array<string> {
    let searchContents = [];
    searchContents = this.searchTag.search_tag_items.map(searchTagItem => {
      return this.translateSearchConditionPipe.transform(
        searchTagItem.column_name,
        searchTagItem.search_value,
        this.searchTag.mail_type
      );
    });
    return searchContents;
  }
}
